<template>
  <div>
    <div class="alert alert-soft-danger pb-4">
      <h4 class="alert-heading">If my current deal expires in 30 days or less, alert me</h4>
      <SelectButton v-model="form.redFrequency" :options="frequencyOptions" optionLabel="label" optionValue="value" />
    </div>
    <div class="alert alert-soft-warning pb-4">
      <h4 class="alert-heading text-warning">If I have between 30 and 90 days, alert me</h4>
      <SelectButton v-model="form.amberFrequency" :options="frequencyOptions" optionLabel="label" optionValue="value" />
    </div>
    <div class="alert alert-soft-success pb-4">
      <h4 class="alert-heading">The rest of the time, alert me</h4>
      <SelectButton v-model="form.greenFrequency" :options="frequencyOptions" optionLabel="label" optionValue="value" />
    </div>
  </div>
</template>

<script>
import SelectButton from 'primevue/selectbutton'

export default {
  name: "ConfigureAlertsForm",
  
  components: {
    SelectButton
  },
  
  props: {
    value: Object
  },
  
  mounted() {
    if (this.value != null) {
      this.form = { ...this.value };
    }
  },

  watch: {
    value: {
      handler: function(val, oldVal) {
        if (val != null && JSON.stringify(val) !== JSON.stringify(oldVal)) {
          this.form = { ...val };
        }
      }
    },
    
    form: {
      deep: true,
      handler: function (val, oldVal) { 
        this.$emit("input", val); 
      }
    }
  },
  
  data() {
    return {
      form: {
        redFrequency: 0,
        amberFrequency: 0,
        greenFrequency: 0
      },
      frequencyOptions: [
        { label: "Never", value: 0 },
        { label: "Daily", value: 1 },
        { label: "Weekly", value: 7 },
        { label: "Monthly", value: 30 }
      ]
    }
  },
  
  computed: {
  }
}
</script>

<style scoped>

</style>